import { useEffect, useState } from "react"

/**
 * A React hook that listens to and returns the state of a CSS media query.
 *
 * @param {string} query - A valid CSS media query string (e.g., "(min-width: 768px)" or "(prefers-color-scheme: dark)")
 * @returns {boolean} True if the media query matches the current state, false otherwise
 *
 * @example
 * ```jsx
 * function DarkModeAwareComponent() {
 *   const isDarkMode = useMediaQuery('(prefers-color-scheme: dark)');
 *
 *   return (
 *     <div>
 *       Current theme: {isDarkMode ? 'Dark' : 'Light'}
 *     </div>
 *   );
 * }
 */
export function useMediaQuery(query) {
  const [value, setValue] = useState(false)

  useEffect(() => {
    function onChange(event) {
      setValue(event.matches)
    }

    const result = matchMedia(query)
    result.addEventListener("change", onChange)
    setValue(result.matches)

    return () => result.removeEventListener("change", onChange)
  }, [query])

  return value
}
